<template>
  <div class="page">
    <!--    <nav-bar title="我的推广二维码" left-text="返回" left-arrow @click-left="goBack" :fixed="false" :placeholder="true"/>-->
    <notice-bar>长按图片可以保存到手机</notice-bar>
    <van-image v-if="spreadImage" :src="spreadImage" />
    <empty v-else description="图片加载中"></empty>
  </div>
</template>
<script>
import { NoticeBar, Image as VanImage, Empty, Toast } from "vant";
import { getSpreadImage } from "@api/activity";
export default {
  props: {
    attr: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      id: this.$route.params.id,
      base64: null,
      spreadImage: null,
    };
  },
  components: {
    VanImage,
    NoticeBar,
    Empty,
  },
  mounted: function () {
    this.getSpreadImg();
  },
  methods: {
    getSpreadImg() {
      Toast("为确保您的推广可以成功提现，请先关注悦记会员公众号！");
      getSpreadImage(this.id).then((res) => {
        this.base64 = res.result;
        this.spreadImage = "data:image/png;base64," + this.base64;
      });
    },
    goBack: function () {
      this.$router.go(-1);
    },
  },
};
</script>
